import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=4f9f25bc&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"
import style0 from "./UserList.vue?vue&type=style&index=0&id=4f9f25bc&prod&scoped=true&lang=less"
import style1 from "./UserList.vue?vue&type=style&index=1&id=4f9f25bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f25bc",
  null
  
)

export default component.exports